import React from "react";
import {
  InterfaceRequirementListPageContent,
  InterfaceRequirementListPageStateProvider,
} from ".";

export const InterfaceRequirementListPage = () => {
  return (
    <InterfaceRequirementListPageStateProvider>
      <InterfaceRequirementListPageContent></InterfaceRequirementListPageContent>
    </InterfaceRequirementListPageStateProvider>
  );
};
